<template>
  <div class="ratings">
    <RatingTitle 
      :title="slide.title"
      @prev="$emit('prev')"
      @next="$emit('next')"
    />
    
    <RatingTable 
      :data="slide.data"
      :currentUserId="user._id"
    />
  </div>
</template>


<script>
import RatingTitle from './Title';
import RatingTable from './Table';

export default {
  name: 'AppRating',

  emits: ['prev', 'next'],

  components: {
    RatingTitle,
    RatingTable,
  },

  props: {
    slide: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    user: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>


<style lang="scss" scoped>
.ratings {
  max-width: 620px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;

  & > header {
    z-index: 1;
  }
}
</style>